import { render, staticRenderFns } from "./TableEvaluatedCategories2.vue?vue&type=template&id=fa5738fa&"
import script from "./TableEvaluatedCategories2.vue?vue&type=script&lang=js&"
export * from "./TableEvaluatedCategories2.vue?vue&type=script&lang=js&"
import style0 from "./TableEvaluatedCategories2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports